import {ContentElementKey} from "./content-element-key";

export const contentElement = (key: ContentElementKey, defaultValue: string = `[${key}]`): string => {
    // @ts-ignore
    return window?.modelContainer?.productModel?.texts[key] || defaultValue;
}